import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getResearchArticleIndexPath } from 'site-modules/editorial/utils/content-path';
import { TypeArticle } from 'site-modules/editorial/pages/type/article';

function ResearchTypeUI({ content = null, articleCategory, splat = null, articleId }) {
  if (!content) {
    return null;
  }

  return <TypeArticle content={content} slug={articleCategory} splat={splat} articleId={articleId} />;
}

ResearchTypeUI.propTypes = {
  articleCategory: PropTypes.string.isRequired,
  articleId: PropTypes.string.isRequired,
  splat: PropTypes.string,
  content: CmsEntities.Content,
};

export const ResearchType = connectToModel(ResearchTypeUI, {
  content: bindToContent(({ articleCategory, articleId, splat }) =>
    getResearchArticleIndexPath(articleCategory, articleId, splat)
  ),
});
